import type {
  Hint,
  MeetingSummary,
  PluginContext,
  PluginDataScope,
  TranscriptLine,
} from "@scoach/types";

/** Build the read-only context handed to a LIVE-screen plugin, filtered to its
 * data scope (transcript only for "full"). */
export function buildLiveContext(args: {
  scope: PluginDataScope;
  meetingId: string;
  company?: string;
  meetingType?: string;
  role?: string;
  hints: Hint[];
  followups: string[];
  transcript: TranscriptLine[];
}): PluginContext {
  const ctx: PluginContext = {
    surface: "live",
    dataScope: args.scope,
    meeting: {
      id: args.meetingId,
      company: args.company,
      meetingType: args.meetingType,
      role: args.role,
    },
    hints: args.hints,
    followups: args.followups,
  };
  if (args.scope === "full") ctx.transcript = args.transcript;
  return ctx;
}

/** Build the read-only context handed to a SUMMARY-screen plugin, filtered to its
 * data scope (summary/transcript only for "full"). */
export function buildSummaryContext(args: {
  scope: PluginDataScope;
  meetingId: string;
  company?: string;
  meetingType?: string;
  summary: MeetingSummary | null;
  transcript?: TranscriptLine[];
}): PluginContext {
  const ctx: PluginContext = {
    surface: "summary",
    dataScope: args.scope,
    meeting: { id: args.meetingId, company: args.company, meetingType: args.meetingType },
  };
  if (args.scope === "full") {
    ctx.summary = args.summary;
    if (args.transcript) ctx.transcript = args.transcript;
  }
  return ctx;
}
